<template>
  <footer id="postEditorFooter">
    <tool-bar-status-btn />
    <PostWordsCounter />
    <ConfirmHeading />
  </footer>
</template>

<script>
import PostWordsCounter from '../parts/PostWordsCounter'
import ToolBarStatusBtn from '../parts/ToolBarStatusBtn'
import ConfirmHeading from '../parts/ConfirmHeading'

export default {
  components: {
    PostWordsCounter,
    ToolBarStatusBtn,
    ConfirmHeading
  }
}
</script>

<style scoped>
#postEditorFooter {
  height: 50px;
  width: 100%;
  background-color: #fff;
  border-top: 1px solid #a9a9a9;
  display: flex;
  flex-direction: row-reverse;
  padding: 10px 200px;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
}
</style>
